// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__JK1pa","productName":"Table_productName__zrXWB"};